import React, { useEffect, useState } from 'react'
import * as helper from '../global/helper';

const AddDocumentModal = (props) => {

    const [document,             setDocument]             = useState({FileName: 'Aadhaar Card'});
    const [file,                 setFile]                 = useState(null)

    useEffect(() => {
        $('#document-modal').modal({ backdrop: 'static' });

        $('#document-modal').on('hidden.bs.modal', function () {
            props.onDismissModal(); 
        });

        $('#document-modal').modal('toggle');
    }, [props.show]);

    const updateContactDetails = (field, value) => {   
        setDocument((d) => {
            return { ...d, [field]: value };
        });
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0]; // Get the first selected file
        setFile(selectedFile); // Store the file in the state
      };

    const AddDocumentHandler = async (e) => {
        e.preventDefault()
        const btn = $('#btnContactSave');
        var form = $('#add-document-form');

        form.validate({
            rules: {
                txtMobile: {
                    required: true,
                    number: true,
                    minlength: 10,
                    maxlength: 10,
                },
                txtContactName: {
                    required: true
                }, 
            },
            messages: {
                txtMobile: {
                    required: "Please enter mobile",
                },
                txtContactName: {
                    required: "Please enter name",
                },
            }
        });

        if (!form.valid()) return;

        try {
            props.setDocumentList(c => ([...c, {...document, file}]))
            $("#document-modal").modal("hide");
        } catch (err) {
            swal.fire({
                icon                : 'error',
                titleText           : 'Error!',
                text                : err.message,
                buttonsStyling      : false,
                confirmButtonClass  : 'btn btn-brand',
            }); 
        }
    }

    return (
        <div className="modal fade" id="document-modal" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title"> Add Contact </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"> </button>
                    </div>
                    <form className='' id='add-document-form'>
                        <div className="modal-body">
                            <div className="modal-body padding-25 padding-b0">
                                <div id="document-modal-holder" className="kt-form kt-form--label-right padding-10" role="form">
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Document Name <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8">
                                            <select 
                                                id="txtContactName" 
                                                className="form-control kt-selectpicker"
                                                value={document.FileName || ''}
                                                onChange={(event) => updateContactDetails('FileName', event.target.value)}
                                                name="txtContactName">
                                                <option value="Aadhaar Card">Aadhaar Card</option>
                                                <option value="Pan Card">Pan Card</option>
                                                <option value="Driving Licence">Driving Licence</option>
                                                <option value="Electricity Bill">Electricity Bill</option>
                                                <option value="Ration Card">Ration Card</option>
                                                <option value="Others">Others</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Upload Document <span className="red">*</span></label>
                                        <div className="col-xl-6 col-lg-8 flex" style={{ alignContent: 'center' }}>
                                            {file ? (
                                                <span className=''>{file.name}</span>
                                            ) : (
                                                <input type="file" onChange={handleFileChange}  className="form-control-file" placeholder='Upload Files' id="file-upload" />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer padding-tb10">
                                <button type="button" data-dismiss="modal" className="btn btn-secondary margin-0 margin-r5 " id="btn_close">Close </button>
                                <button type="button" className="btn btn-brand margin-0 " id="btnContactSave" onClick={AddDocumentHandler}>Add </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddDocumentModal